import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import account from './account'
/**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/help/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
    const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: status.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
        statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\GuestHelpController::status
 * @see app/Http/Controllers/GuestHelpController.php:37
 * @route '/help/status'
 */
        statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    status.form = statusForm
/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:93
 * @route '/help/ask'
 */
export const ask = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(options),
    method: 'post',
})

ask.definition = {
    methods: ["post"],
    url: '/help/ask',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:93
 * @route '/help/ask'
 */
ask.url = (options?: RouteQueryOptions) => {
    return ask.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:93
 * @route '/help/ask'
 */
ask.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:93
 * @route '/help/ask'
 */
    const askForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: ask.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:93
 * @route '/help/ask'
 */
        askForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: ask.url(options),
            method: 'post',
        })
    
    ask.form = askForm
/**
* @see \App\Http\Controllers\GuestHelpController::feedback
 * @see app/Http/Controllers/GuestHelpController.php:127
 * @route '/help/feedback'
 */
export const feedback = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: feedback.url(options),
    method: 'post',
})

feedback.definition = {
    methods: ["post"],
    url: '/help/feedback',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\GuestHelpController::feedback
 * @see app/Http/Controllers/GuestHelpController.php:127
 * @route '/help/feedback'
 */
feedback.url = (options?: RouteQueryOptions) => {
    return feedback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GuestHelpController::feedback
 * @see app/Http/Controllers/GuestHelpController.php:127
 * @route '/help/feedback'
 */
feedback.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: feedback.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\GuestHelpController::feedback
 * @see app/Http/Controllers/GuestHelpController.php:127
 * @route '/help/feedback'
 */
    const feedbackForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: feedback.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\GuestHelpController::feedback
 * @see app/Http/Controllers/GuestHelpController.php:127
 * @route '/help/feedback'
 */
        feedbackForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: feedback.url(options),
            method: 'post',
        })
    
    feedback.form = feedbackForm
const guestHelp = {
    status: Object.assign(status, status),
ask: Object.assign(ask, ask),
feedback: Object.assign(feedback, feedback),
account: Object.assign(account, account),
}

export default guestHelp